import { Organization } from '@informme/shared/schemas/stage2/OrgSchemas';
import { TEST_ORG_ID } from './TestQRData';

export { TEST_ORG_ID };

export const TEST_ORGANIZATION: Organization = {
  orgId: TEST_ORG_ID,
  name: 'Test Medical Practice',
  ISOCountryCode: 'US',
  i18nLocale: 'en',
  sites: [
    {
      siteId: 'test-site-001',
      city: 'Test City',
      formIds: ['form-demo-20'],
      calendarIds: [],
      risSiteIds: ['test-ris-site'],
    },
  ],
  visible: true,
  formIds: ['form-demo-20'],
  predefinedComments: {},
  appointmentFormIds: {},
  env: {
    ENABLE_DYNAMODB: true,
    FE_ENABLE_REMOTE_FORMS: true,
  },
};
